import { Component, OnInit, AfterViewInit } from '@angular/core';
import { WindowService } from "../services/window.service";
import { Router, ActivatedRoute } from "@angular/router";
import {
    MainConfigurationInterface,
    ConfigurationLoader
} from "../services/configuration.loader";
import { RoomsIterator } from "../utils/room.iterator";

import { TranslateService } from '@ngx-translate/core';
import { LocalTranslateService } from "../services/local_translate.service";

@Component({
    selector: 'intro',
    templateUrl: './intro.component.html'
})
export class IntroComponent implements OnInit, AfterViewInit {
    public storeId = 1;
    // public currentLang;

    public defaultImage = 'img/default_image.gif';
    public pageTitle = "";

    public rooms: RoomsIterator = null;

    public mainConfiguration: MainConfigurationInterface = {
        Client: "Norrlands Trä",
        MagentoUrl: "",
        LogoUrl: "",
        PageTitle: "",
        StartScreen: {
            "Title": "Välj din miljö!",
            "Subtitle1": "Välkommen till vårt designverktyg för att inspireras!",
            "Subtitle2": "Börja med att välja din miljö för att sedan se hur den ser ut med olika paneler och golv.",
            "BackgroundImage": "img/intro-bg.jpg"
        },
        Email: {
            "Subject": "Norrlands Trä",
            "FromAddress": "noreply@norrlandstra.se",
            "Body": "Hej!\n\nKolla in min design hos"
        },
        PriceUnit: "Kr/m2",
        ShowPrice: false,
        ShowSumPrice: false,
        Room: []
    };

    constructor(public localTranslate: LocalTranslateService, public translate: TranslateService, public winService: WindowService, public router: Router, public route: ActivatedRoute, public configuratorLoader: ConfigurationLoader) {
    }

    updatePageTitle() {
        this.translate.get(this.pageTitle).subscribe((res: string) => {
            window.document.title = res;
        });
    }

    ngOnInit(): any {
        this.route.params.subscribe((data: any) => {
            const storeId = data.store;
            // const currentLang = this.localTranslate.getCurrentLang().split('_')[0];

            if (typeof storeId !== 'undefined') {
                this.storeId = parseInt(storeId);
            }

            // this.currentLang = currentLang;

            this.localTranslate.setCurrentLang(this.storeId);
        });
        this.winService.scale();

        this.configuratorLoader.setStore(this.storeId);
        this.configuratorLoader.load().subscribe((conf: MainConfigurationInterface) => {
            this.mainConfiguration = conf;
            this.pageTitle = this.mainConfiguration.PageTitle;
            this.updatePageTitle();
            this.rooms = new RoomsIterator(this.mainConfiguration.Room);

            var img = new Image();
            img.src = this.mainConfiguration.StartScreen.BackgroundImage;

            img.addEventListener('load', () => {
                $('.bg').css('background-image', 'url(' + this.mainConfiguration.StartScreen.BackgroundImage + ')');
                $('.bg').animate({ opacity: 1 }, 500);
            });
        })
    }

    ngAfterViewInit(): any {

    }

    goToRoom(index) {
        let route = "/configurator";
        this.router.navigate([route, this.storeId, index]);
    }

    rebnderHtml(text) {
        return
    }
}


// WEBPACK FOOTER //
// ./src/app/intro/intro.component.ts